export default {
    "iot-alert-mgmt.10001": "Save alert rule error, it is invalid",
    "iot-alert-mgmt.10002": "Save alert rule error, it's name is duplicate",
    "iot-alert-mgmt.10003": "Update alert rule status error, it's status is invalid",
    "iot-alert-mgmt.10004": "Alert rule is not exist",
    "iot-alert-mgmt.10005": "Elasticsearch error",
    "iot-alert-mgmt.10006": "Alert rule ruleType is invalid",
    "iot-alert-mgmt.10007": "Edge computing rule name is duplicate",
    "iot-alert-mgmt.10008": "Edge computing rule is not exist",
    "iot-alert-mgmt.10009": "Edge computing rule issuance history is not exist",
    "iot-alert-mgmt.10010": "Edge computing rule issuance message[id] is not exist",
    "iot-alert-mgmt.10011": "Can not find specification for tenant[id]",
    "iot-alert-mgmt.10012": "Rule count exceeds limit",
    "iot-alert-mgmt.10013": "Things forward rule[id] is not exist",
    "iot-alert-mgmt.10014": "Things select size is 0",
    "iot-alert-mgmt.10015": "Save things forward rule error, name is duplicate",
    "iot-alert-mgmt.10016": "Update alert rule error, alert type cannot be changed.",
    "iot-alert-mgmt.10017": "Twins rule is not exist ",
    "iot-alert-mgmt.10019": "Save alert rule error, trigger_condition is too long",
}